import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledDrawerFooter } from './styles';

export interface DrawerFooterProps {
  buttonsList?: React.ReactNode[];
  theme?: any;
}

const FooterComponent: React.FC<DrawerFooterProps> = ({ buttonsList }: DrawerFooterProps) => {
  return (
    <StyledDrawerFooter>
      {buttonsList?.map((button, index) => <React.Fragment key={index}>{button}</React.Fragment>)}
    </StyledDrawerFooter>
  );
};

export const Footer = withTheme(FooterComponent);
